import {
  buildJobsUrl,
  buildManageJobUrl,
} from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import { defineEmailNotificationHandler } from "./types";

const ApplicationDailyDigestSchema = z.object({
  totalUnreviewed: z.number(),
  jobs: z.array(
    z.object({
      jobId: z.string(),
      title: z.string(),
      unreviewedCount: z.number(),
      strongMatches: z.number(),
    })
  ),
});

export const applicationDailyDigestHandler = defineEmailNotificationHandler({
  type: "application.daily_digest",
  icon: "application",
  title() {
    return "Daily application digest";
  },
  description() {
    return "A daily summary of applications awaiting review.";
  },
  schema: ApplicationDailyDigestSchema,
  buildEmailPayload(data, recipient, { baseUrl, unsubscribeUrl }) {
    const totalStrongMatches = data.jobs.reduce(
      (sum, job) => sum + job.strongMatches,
      0
    );

    return {
      name: "email/application.daily_digest",
      data: {
        userId: recipient.userId,
        to: recipient.email,
        from: buildFromAddress(),
        recipientName: recipient.name,
        totalUnreviewed: data.totalUnreviewed,
        totalStrongMatches,
        jobs: data.jobs.map((job) => ({
          jobTitle: job.title,
          unreviewedCount: job.unreviewedCount,
          strongMatches: job.strongMatches,
          manageJobUrl: buildManageJobUrl({ baseUrl, jobId: job.jobId }),
        })),
        jobsUrl: buildJobsUrl(baseUrl),
        unsubscribeUrl,
      },
    };
  },
});
